var _circle, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path2, _path3, _rect15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonSmoke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 52.5,
    fill: "white",
    stroke: "#DDDDED",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.8964 39.4317C86.8974 38.9649 88.0874 39.398 88.5542 40.399L91.6666 47.0735C92.1334 48.0746 91.7003 49.2645 90.6992 49.7314L76.3985 56.3999L71.5957 46.1002L85.8964 39.4317Z",
    fill: "#EB996E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.4785,
    y: 45.5356,
    width: 0.667148,
    height: 2.33502,
    transform: "rotate(-58.1016 75.4785 45.5356)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82.1475,
    y: 51.4712,
    width: 0.667148,
    height: 2.33502,
    transform: "rotate(-58.1016 82.1475 51.4712)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 81.0127,
    y: 47.0835,
    width: 0.667148,
    height: 2.33502,
    transform: "rotate(-82.5078 81.0127 47.0835)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 82.3447,
    y: 42.814,
    width: 0.879799,
    height: 1.71989,
    transform: "rotate(-45.9619 82.3447 42.814)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80.0928,
    y: 45.1938,
    width: 0.667148,
    height: 1.3769,
    transform: "rotate(-145.498 80.0928 45.1938)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76.7861,
    y: 54.2202,
    width: 0.667148,
    height: 1.3769,
    transform: "rotate(-145.498 76.7861 54.2202)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 86.8955,
    y: 49.6431,
    width: 0.522241,
    height: 2.28285,
    transform: "rotate(-87.7775 86.8955 49.6431)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 85.7227,
    y: 47.3555,
    width: 0.522241,
    height: 2.28285,
    transform: "rotate(-139.687 85.7227 47.3555)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 89.0059,
    y: 41.4229,
    width: 0.52224,
    height: 2.28285,
    transform: "rotate(-124.38 89.0059 41.4229)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 72.3867,
    y: 49.3374,
    width: 0.522241,
    height: 1.58012,
    transform: "rotate(-87.7775 72.3867 49.3374)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8926,
    y: 42.7017,
    width: 0.52224,
    height: 1.41015,
    transform: "rotate(-119.519 85.8926 42.7017)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 78.0088,
    y: 49.418,
    width: 0.52224,
    height: 1.41015,
    transform: "rotate(-119.519 78.0088 49.418)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 72.2383,
    y: 45.6846,
    width: 11.3645,
    height: 50.0036,
    transform: "rotate(65 72.2383 45.6846)",
    fill: "#F4DFD4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 72.2822,
    y: 45.7798,
    width: 11.3645,
    height: 4.54578,
    transform: "rotate(65 72.2822 45.7798)",
    fill: "#F4AB85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0793 31.3109C28.3119 31.5125 25.9936 32.9642 24.9226 36.7184C24.38 38.4876 24.3166 40.8757 25.3454 43.1924C25.8528 44.2428 26.8111 45.4806 27.5369 46.5167C28.2768 47.7687 29.2492 49.2223 29.1436 50.9629C29.0379 52.7036 27.8118 54.084 26.776 55.0185C25.7402 55.9531 24.4859 56.9019 23.6685 57.8221C21.8012 59.4611 21.3009 61.8777 21.4278 63.8199C21.5546 65.7621 22.3086 67.2299 23.0203 68.0503C23.732 68.8707 24.1971 69.2737 24.2112 69.4895C24.2112 69.4895 23.5418 69.3166 22.8301 68.4962C22.1184 67.6758 21.146 66.2222 20.7866 64.0785C20.4413 62.1506 20.9133 59.3024 22.9709 57.2175C24.0067 56.283 25.0425 55.3485 26.0784 54.4139C27.1142 53.4794 27.9175 52.3433 28.0514 51.0343C28.1852 49.7252 27.4453 48.4732 26.7054 47.2212C25.9655 45.9692 25.0213 44.9473 24.4998 43.681C23.4569 41.1485 23.5062 38.5447 24.2531 36.5454C24.7816 34.5604 26.0077 33.18 26.8392 32.4755C27.4381 31.5695 28.0793 31.3109 28.0793 31.3109Z",
    fill: "#6C6D8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9942 24.3254C39.2077 24.3736 37.3795 25.5127 36.7126 28.466C36.3792 29.9426 36.2117 31.6784 37.1594 33.4444C37.6571 34.2219 38.1071 35.2103 38.8184 36.036C39.4819 37.0727 40.1455 38.1094 40.0256 39.6342C39.9057 41.1591 39.0269 42.0691 38.1482 42.9792C37.317 43.6784 36.4859 44.3775 35.6548 45.0766C34.2537 46.3122 33.825 48.2107 33.9662 49.5728C34.2011 52.508 36.1459 53.834 35.9323 53.7858C35.9323 53.7858 35.5053 53.6893 34.7464 53.0746C34.2011 52.508 33.3716 51.2122 33.0645 49.5909C32.7573 47.9696 33.2337 45.8601 34.73 44.2027C35.5612 43.5036 36.3923 42.8044 37.2234 42.1053C38.0546 41.4062 38.6721 40.6588 38.6968 39.5559C38.912 37.6091 36.8489 35.813 35.9488 33.8361C35.0487 31.8592 35.3115 29.7015 35.645 28.2249C37.0001 25.2054 39.0418 24.1145 38.9942 24.3254Z",
    fill: "#6C6D8A"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4629,
    y: 19.2056,
    width: 6,
    height: 103,
    transform: "rotate(-45 16.4629 19.2056)",
    fill: "#DDDDED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonSmoke);
export default __webpack_public_path__ + "static/media/non-smoke.7522cb9f2e4884d92f0a860ed438555a.svg";
export { ForwardRef as ReactComponent };